import { type AxiosError } from 'axios'
import { throttle } from 'lodash'
import { uiStore } from 'shared/store/uiStore'
import { IS_APP_LIGHT } from 'shared/config'
import { logger } from 'shared/lib'
import { AuthApi } from 'entities/Auth/api'
import {
  getAssumeToken,
  removeTokenLocalStorage,
  setTokenHeaderFromViaConfig,
  setTokenLocalStorage,
} from 'entities/Auth/lib/setToken'
import { baseApi } from 'entities/Auth/lib'
import { logout } from 'entities/Auth/lib/logout'
import { AuthPath } from 'pages/auth/route/authPath'
import { RegisterPath } from 'pages/register/route/registerPath'

const maxAge = 10000
const handleRefreshToken = async () => {
  try {
    const { data } = await AuthApi.updateAuthRefresh()
    const isBoolean = typeof data.is_login === 'boolean'
    const isAssume = Boolean(getAssumeToken())

    if (isBoolean && !data.is_login) {
      removeTokenLocalStorage(isAssume)
      await logout()
    }

    if (isBoolean && data.is_login) {
      setTokenLocalStorage(data.token.access_token, isAssume)
    }
  } catch (e) {
    logger.error(e)
  }
}

const handleLogout = async () => {
  try {
    const isAssume = Boolean(getAssumeToken())
    removeTokenLocalStorage(isAssume)
    await logout()

    if (
      window.location.href.includes(AuthPath.login) ||
      window.location.href.includes(RegisterPath.root) ||
      IS_APP_LIGHT
    )
      return
    uiStore.changeRoute({
      path: `/${AuthPath.login}`,
    })
  } catch (e) {
    logger.error(e)
  }
}

const throttleHandleRefreshToken = throttle(handleRefreshToken, maxAge, { trailing: false })
const throttleHandleLogout = throttle(handleLogout, maxAge, { trailing: false })

export const rejectRefreshToken = async (error: AxiosError<{ auth_required: boolean }>) => {
  const response = error.response
  const authRequired = response?.data?.auth_required
  const isRefresh = authRequired === true
  const isLogout = authRequired === false
  const config = error?.config

  if (!config?.url?.includes('segment/v1/events')) {
    // errorLogger(error) TODO: in progress
  }

  if (config?.url?.includes('logger/v1/logs')) {
    return Promise.reject(error)
  }

  if (isRefresh) {
    await throttleHandleRefreshToken()

    if (config) {
      setTokenHeaderFromViaConfig(config)
    }

    return config ? baseApi.request(config) : null
  }

  if (isLogout) {
    await throttleHandleLogout()
  }
  return Promise.reject(error)
}
